export interface IRpcResponse<T> {
    id: number;
    jsonrpc: string;
    result: T;
    error?: IRpcError;
}

export interface IRpcError {
    code: ExceptionCode;
    message: string;
    data: any;
}

export enum ExceptionCode
{
    Empty = 0,
    WrongGuid = 1,
    NotFoundObjects = 2,
    AccessDenied = 3,
    WrongEnum = 4,
    NonValid = 5,
    WrongSettings = 1001,
    // BeOpenHub.Internal.HttpStatusCodeNew.MenuServiceException (be-open-hub, backend).
    // Listed here so RpcErrorInterceptorService treats it as "known" and skips the generic
    // error snackbar - the components that trigger menu upload/cancel show their own message.
    MenuServiceException = 443,
}
